import { Renewal } from "pmt-types/src/models/Renewal.ts";
import { PagedApiData } from "pmt-types/src/utils/PagedApiData.ts";
import { useQuery } from "react-query";
import { Maybe } from "../../utils/types/maybe.ts";
import { useAuthentication } from "../useAuthentication.ts";
import { QueryKeys } from "./queryKeys.ts";

export const useQueryGetRenewalsForProjectId = (
  sourceId: Maybe<string>,
  projectId: Maybe<string>,
) => {
  const { accessToken } = useAuthentication();

  return useQuery(
    [QueryKeys.GetProjectRenewals, projectId],
    async () => {
      const response = await fetch(
        `${
          import.meta.env.VITE_API_HOST
        }/sources/${sourceId}/projects/${projectId}/renewals`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            authorization: accessToken ?? "",
          },
        },
      );

      if (!response.ok) {
        throw new Error("Failed to query project enrollees");
      }

      const apiData = (await response.json()) as PagedApiData<Renewal>;

      return apiData?.data ?? [];
    },
    {
      enabled: sourceId != null && projectId != null && projectId !== "new",
      onError: (error) => {
        console.error("Failed to get renewals for project", error, sourceId);
      },
    },
  );
};
